<template>
    <modal id="leave-type-modal"
           v-model="showModal"
           :title="generateModalTitle('leave_type')"
           @submit="submitData"
           :loading="loading"
           :preloader="preloader">
        <form ref="form" :data-url='this.selectedUrl ? this.selectedUrl : apiUrl.LEAVE_TYPES'>
            <app-form-group
                :label="$t('name')"
                v-model="formData.name"
                :placeholder="$placeholder('name', '')"
                :required="true"
                :error-message="$errorMessage(errors, 'name')"
            />

            <app-form-group
                :label="$t('type')"
                type="select"
                v-model="formData.type"
                :list="getLeaveTypes"
                :placeholder="$placeholder('type', '')"
                :error-message="$errorMessage(errors, 'type')"
            />

            <app-form-group
                v-if="formData.type === 'special'"
                :label="$t('special_percentage')"
                type="decimal"
                v-model="formData.special_percentage"
                :placeholder="$placeholder('special_percentage', '')"
                :error-message="$errorMessage(errors, 'special_percentage')"
            />

            <app-form-group
                :label="$t('amount')"
                type="decimal"
                v-model="formData.amount"
                :placeholder="$placeholder('amount', '')"
                :required="true"
                :error-message="$errorMessage(errors, 'amount')"
            />

            <app-form-group
                :label="$t('total_annual_leave')"
                v-model="formData.total_annual_leave"
                :placeholder="$placeholder('total_annual_leave', '')"
                :required="true"
                :error-message="$errorMessage(errors, 'total_annual_leave')"
            />
            <app-form-group
                :label="$t('max_per_month')"
                v-model="formData.max_per_month"
                :placeholder="$placeholder('max_per_month', '')"
                :required="true"
                :error-message="$errorMessage(errors, 'max_per_month')"
            />

            <app-form-group
                :label="$t('max_per_year')"
                v-model="formData.max_per_year"
                :placeholder="$placeholder('max_per_year', '')"
                :required="true"
                :error-message="$errorMessage(errors, 'max_per_year')"
            />

            <app-form-group
                :label="$t('bonus_leave')"
                type="decimal"
                v-model="formData.bonus_leave"
                :placeholder="$placeholder('bonus_leave', '')"
                :required="true"
                :error-message="$errorMessage(errors, 'bonus_leave')"
            />

            <app-form-group
                :label="$t('bonus_leave_credit_month')"
                type="select"
                v-model="formData.bonus_leave_credit_month"
                :list="getMonth"
                :placeholder="$placeholder('bonus_leave_credit_month', '')"
                :error-message="$errorMessage(errors, 'bonus_leave_credit_month')"
            />

            <app-form-group
                :label="$t('bonus_min_employment_duration')"
                v-model="formData.bonus_min_employment_duration"
                :placeholder="$placeholder('bonus_min_employment_duration', '')"
                :required="true"
                :error-message="$errorMessage(errors, 'bonus_min_employment_duration')"
            />
            <div class="d-flex justify-content-between">
                <app-form-group
                    :label="$t('enabled')"
                    type="radio"
                    :radio-checkbox-name="'enabled'"
                    v-model="formData.is_enabled"
                    :required="true"
                    :list="[{'id': 1, 'value': 'Yes'}, {'id': 0, 'value': 'No'}]"
                    :error-message="$errorMessage(errors, 'is_enabled')"
                />
                <app-form-group
                    :label="$t('is_earning_enabled')"
                    type="radio"
                    :radio-checkbox-name="'is_earning_enabled'"
                    v-model="formData.is_earning_enabled"
                    :required="true"
                    :list="[{'id': 1, 'value': 'Yes'}, {'id': 0, 'value': 'No'}]"
                    :error-message="$errorMessage(errors, 'is_earning_enabled')"
                />
                <app-form-group
                    :label="$t('is_attachment_enabled')"
                    type="radio"
                    :radio-checkbox-name="'is_attachment_enabled'"
                    v-model="formData.is_attachment_enabled"
                    :required="true"
                    :list="[{'id': 1, 'value': 'Yes'}, {'id': 0, 'value': 'No'}]"
                    :error-message="$errorMessage(errors, 'is_attachment_enabled')"
                />
            </div>
        </form>
    </modal>
</template>

<script>
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import {addSelectInSelectArray} from "../../../../../common/Helper/Support/FormHelper";

export default {
    name: "LeaveTypeCreateEditModal",
    mixins: [ModalMixin, FormHelperMixins],
    data() {
        return {
            formData: {
                total_annual_leave: '',
                max_per_month: '',
                max_per_year: '',
                bonus_leave:'',
                bonus_min_employment_duration:'',
                bonus_leave_credit_month:'',
                is_enabled: true,
                is_earning_enabled: true,
                is_attachment_enabled:false,
            }
        }
    },
    methods: {
        afterSuccess({data}) {
            this.toastAndReload(data.message, 'leave-types-table');
            this.formData = {};
            $('#leave-type-modal').modal('hide');
            this.$emit('input', false);
        }
    },
    computed: {
        getLeaveTypes() {
            return addSelectInSelectArray([
                {id: 'paid', value: this.$t('paid')},
                {id: 'unpaid', value: this.$t('unpaid')},
            ], 'value', 'type');
        },
        getMonth() {
            let months = [];
            // Add month numbers 1 to 12
            for (let i = 1; i <= 12; i++) {
                months.push({ id: i, value: i });
            }
            return addSelectInSelectArray(months, 'value', 'month');
        }
    }
}
</script>

<style scoped>

</style>
